import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

import { retry } from 'src/utils';

import { postFacebookEvent } from '@features/Analytics/api/facebook';
import type { TpFacebookParameters } from '@features/Analytics/types';

export const useFacebookEvent = () => {
  const externalId = Cookies.get('extId');
  const fbp = Cookies.get('_fbp');

  const { mutateAsync: postEvent } = useMutation({
    mutationFn: postFacebookEvent,
  });

  const conditionCheckFunction = useCallback(
    async () =>
      // @ts-ignore
      window?.fbq != null,
    [],
  );

  const fetchClientEventWithRetry = useCallback(
    async ({ eventName, postPath, options }: TpFacebookParameters) => {
      const eventId = `${eventName}.${fbp}`;
      const actionFunction = async () => {
        // @ts-ignore
        window?.fbq?.('track', eventName, options, {
          eventID: eventId,
          extern_id: externalId,
        });
      };

      await retry({
        conditionCheckFunction,
        actionFunction,
        retryDelay: 500,
      });

      await postEvent({
        eventId,
        postPath,
        fbp: fbp ?? '',
        options,
        ...(externalId != null && { externalId }),
      });
    },
    [conditionCheckFunction, externalId, fbp, postEvent],
  );

  return useMemo(
    () => ({
      clientEvent: ({ eventName, postPath, options }: TpFacebookParameters) => {
        fbp &&
          fetchClientEventWithRetry({
            eventName,
            postPath,
            options,
          });
      },
    }),
    [fbp, fetchClientEventWithRetry],
  );
};
